import React from "react";
import icons from "./icons";

const Icon = ({ icon, ...props }) => {
  const IconComponent = icons[icon];

  return <IconComponent {...props} />;
};

export default Icon;
